module.exports = "../dist/frontend/icons/ui/callUs.svg?8801b4f021670c5995986b607191bc28";